<template>
  <div class="wrapper-page">
    <div class="col-12" v-show="!isLoading">
      <div class="title_container">
        <div class="title_page">{{ tituloActuacion }}</div>
      </div>
      <div class="title_container_mensaje">
        <q-icon name="info" />
        <span
          >Este presupuesto es de carácter provisional. Deberá ser estudiado con
          más detalle y ratificado por el personal de AQUATEC.</span>
      </div>
      <div class="row">
        <div class="container_box">
          <Contenedor
            titulo-container="Tecnología más óptima"
            v-bind:titulo-tecnologia="comp_tecnologia"
            v-bind:propietario_nombre_completo="comp_nombre_completo"
            v-bind:propietario_email="comp_email"
            v-bind:propietario_empresa="comp_empresa"
            v-bind:propietario_telefono="comp_telefono"
            is-text="true"
            download-pdf="true"
            :url="url_PDF"
            :titulo-presupuesto="comp_nombre_actuacion"
            show-offer="true"
            :show-offer-estado-presupuesto="estado_id"
          />
        </div>
        <div class="container_box">
          <Contenedor
            titulo-container="Coste"
            type-container="coste"
            v-bind:data-array="coste"
            v-bind:data-grafica="costes"
          />
        </div>
        <div class="container_box">
          <Contenedor
            titulo-container="Tiempo de ejecución"
            type-container="tiempo_ejecucion"
            v-bind:data-array="tiempo_ejecucion"
            v-bind:data-grafica="tiempos"
          />
        </div>
      </div>
      <div class="row">
        <div class="container_box">
          <Contenedor
            titulo-container="Emisiones de CO2"
            type-container="CO2"
            v-bind:data-array="CO2"
            v-bind:data-grafica="CO2S"
          />
        </div>
        <div class="container_box">
          <Contenedor
            titulo-container="Escombros"
            type-container="escombros"
            v-bind:data-array="escombros"
            v-bind:data-grafica="escombro"
          />
        </div>
        <div class="container_box">
          <Contenedor
            titulo-container="Ruido"
            type-container="ruido"
            v-bind:data-array="ruido"
            v-bind:data-grafica="ruidos"
          />
        </div>
      </div>
      <!--<div class="comp_flex-container col-12">
        <div style="background-color:black;width:396px"></div>
      </div>-->
    </div>
    <cargando :contenido_mensaje="mensaje_cargando" />
  </div>
</template>

<script>
import Contenedor from '@/components/Comparativa/components/Contenedor/contenedor.vue';
import Cargando from '@/components/shared/components/Cargando';

import * as am4core from '@/modules/amcharts4/core';
import * as am4charts from '@/modules/amcharts4/charts';
import am4themes_animated from '@/modules/amcharts4/themes/animated';

import { Cookies } from 'quasar';
import {
  QInput,
  QSelect,
  QCard,
  QList,
  QField,
  QItem,
  QItemSection,
  QItemLabel,
  QCardSection,
  QCardActions,
  QBtnToggle,
  QCheckbox,
  QTable,
  QTh,
  QTr,
  QTd,
  QToggle,
  ClosePopup,
  QDialog,
  QTooltip
} from 'quasar';

// Themes begin
am4core.useTheme(am4themes_animated);

export default {
  computed: {
    sliceTCZ () {
      let variable = 'Presupuesto con zanja';
      let response = '';
      if (variable.length > 10) {
        response = variable.slice(0, 8);
        response += '...';
      } else {
        response = variable;
      }

      return response;
    },
    tituloActuacion () {
      let textString =
        'Presupuesto para la actuación "' +
        this.comp_nombre_actuacion +
        '" en ' +
        this.comp_municipio +
        ' (' +
        this.comp_provincia +
        ')';
      return textString;
    }
  },

  mounted () {
    this.cargar_datos_comparativa();
  },

  methods: {
    /*  Obtención de datos..... */

    loadData () {
      this.hayDatos = false;
      this.cargar_datos_comparativa();
      this.hayDatos = true;
    },

    init () {
      this.cargar_datos_comparativa();
    },

    cargar_datos_comparativa () {
      var id_presupuesto;

      this.$store.commit('TSZ/setOffline', true);
      this.isLoading = true;

      this.$store.commit('TSZ/setHayDatos', true);
      this.hayDatos = false;

      if (
        !(
          this.$route.params.PresupuestoId === 0 ||
          this.$route.params.PresupuestoId === null
        )
      ) {
        id_presupuesto = this.$store.getters['TSZ/idComparativa'];
      } else id_presupuesto = this.$route.params.PresupuestoId;

      let request = {
        controller: '/Presupuestos/' + id_presupuesto + '/Comparativa',
        filter: {},
        data: {
          email: this.$store.getters['TSZ/userMail']
        }
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ_Listado_Comparativa', request)
        .then((response) => {
          this.$store.commit('TSZ/setOffline', false);
          this.isLoading = false;

          (this.comp_nombre_actuacion = response.data.Data.Nombre),
          (this.comp_provincia = response.data.Data.Provincia),
          (this.comp_municipio = response.data.Data.Municipio),
          (this.comp_tecnologia = response.data.Data.Tecnologia),
          (this.comp_nombre_completo =
              response.data.Data.ApellidosPropietario +
              ', ' +
              response.data.Data.NombrePropietario),
          (this.comp_email = response.data.Data.EmailPropietario),
          (this.comp_empresa = response.data.Data.EmpresaPropietario),
          (this.comp_telefono = response.data.Data.TelefonoPropietario),
          (this.coste.tcz = response.data.Data.CosteTcz),
          (this.tiempo_ejecucion.tcz = response.data.Data.TiempoTcz),
          (this.ruido.tcz = response.data.Data.RuidoTcz),
          (this.CO2.tcz = response.data.Data.Co2Tcz),
          (this.escombros.tcz = response.data.Data.EscombroTcz),
          (this.coste.tsz = response.data.Data.CosteTsz),
          (this.tiempo_ejecucion.tsz = response.data.Data.TiempoTsz),
          (this.ruido.tsz = response.data.Data.RuidoTsz),
          (this.CO2.tsz = response.data.Data.Co2Tsz),
          (this.escombros.tsz = response.data.Data.EscombroTsz),
          (this.coste.tsz_porcent = response.data.Data.BeneficioCoste),
          (this.tiempo_ejecucion.tsz_porcent =
              response.data.Data.BeneficioTiempo),
          (this.ruido.tsz_porcent = response.data.Data.BeneficioRuido),
          (this.CO2.tsz_porcent = response.data.Data.BeneficioCo2),
          (this.escombros.tsz_porcent = response.data.Data.BeneficioEscombro),
          (this.url_PDF = response.data.Data.UrlFichaTecnologia),
          (this.estado_id = response.data.Data.EstadoId),
          this.beneficio.push(this.escombros.tsz_porcent);
          this.beneficio.push(this.CO2.tsz_porcent.toFixed(2));
          this.beneficio.push(this.ruido.tsz_porcent.toFixed(2));
          this.costes.push(this.coste.tcz.toFixed(2));
          this.costes.push(this.coste.tsz.toFixed(2));
          this.tiempos.push(this.tiempo_ejecucion.tcz);
          this.tiempos.push(this.tiempo_ejecucion.tsz);
          this.CO2S.push(this.CO2.tcz.toFixed(2));
          this.CO2S.push(this.CO2.tsz.toFixed(2));
          this.escombro.push(this.escombros.tcz.toFixed(2));
          this.escombro.push(this.escombros.tsz.toFixed(2));
          this.ruidos.push(this.ruido.tcz.toFixed(2));
          this.ruidos.push(this.ruido.tsz.toFixed(2));
          this.$store.commit(
            'TSZ/setDatosComparativaBeneficio',
            this.beneficio
          );
          this.$store.commit('TSZ/setDatosComparativaCostes', this.costes);
          this.$store.commit('TSZ/setDatosComparativaTiempos', this.tiempos);

          this.genera_graf_Costes();
          this.genera_graf_Beneficio();
          this.genera_graf_Tiempos();

          this.hayDatos = true;
          this.$store.commit('TSZ/setHayDatos', true);
        })
        .catch((err) => {
          this.$store.commit('TSZ/setOffline', false);
          this.isLoading = false;

          console.log('error_API');
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },

    formato_numero (value) {
      if (value == null || value == 0) {
        value = 0;
        return value;
        // return value.toFixed(2).replace(".", ",");
      } else {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },

    formato_numero_grafica (value) {
      if (value == null || value == 0) {
        value = 0;
        return value.toFixed(2).replace('.', ',');
      } else {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return val.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },

    reiniciar_datos () {
      this.coste.tcz = '';
      this.tiempo_ejecucion.tcz = '';
      this.ruido.tcz = '';
      this.CO2.tcz = '';
      this.escombros.tcz = '';
      this.coste.tsz = '';
      this.tiempo_ejecucion.tsz = '';
      this.ruido.tsz = '';
      this.CO2.tsz = '';
      this.escombros.tsz = '';
      this.coste.tsz_porcent = '';
      this.tiempo_ejecucion.tsz_porcent = '';
      this.ruido.tsz_porcent = '';
      this.CO2.tsz_porcent = '';
      this.escombros.tsz_porcent = '';
      this.beneficio = [];
      this.costes = [];
      this.tiempos = [];

      this.$store.commit('TSZ/setDatosComparativaBeneficio', this.beneficio);
      this.$store.commit('TSZ/setDatosComparativaCostes', this.costes);
      this.$store.commit('TSZ/setDatosComparativaTiempos', this.tiempos);
    }
  },

  watch: {},

  data () {
    return {
      mensaje_cargando: 'Cargando Comparativa...',
      isLoading: false,
      comp_tecnologia: '',
      comp_nombre_actuacion: '',
      comp_provincia: null,
      comp_municipio: null,
      comp_nombre_completo: '',
      comp_email: '',
      comp_empresa: '',
      comp_telefono: '',

      coste: {
        tcz: '',
        tsz: '',
        tsz_porcent: ''
      },
      tiempo_ejecucion: {
        tcz: '',
        tsz: '',
        tsz_porcent: ''
      },
      ruido: {
        tcz: '',
        tsz: '',
        tsz_porcent: ''
      },
      CO2: {
        tcz: '',
        tsz: '',
        tsz_porcent: ''
      },
      escombros: {
        tcz: '',
        tsz: '',
        tsz_porcent: ''
      },

      url_PDF: '',
      estado_id: '',

      beneficio: [],
      costes: [],
      tiempos: [],
      CO2S: [],
      escombro: [],
      ruidos: [],
      hayDatos: false
    };
  },

  components: {
    QInput,
    QSelect,
    QCard,
    QList,
    QField,
    QCardSection,
    QCardActions,
    QBtnToggle,
    QCheckbox,
    QTable,
    QTh,
    QTr,
    QTd,
    QToggle,
    ClosePopup,
    QDialog,
    QTooltip,
    Contenedor,
    Cargando
  }
};
</script>

<style scoped>
.estruct_graf {
  width: 30%;
  height: 300px;
}

.wrapper-page {
  padding-left: 12px;
  padding-right: 12px;
}

.title_container {
  padding-top: 23px;
  padding-bottom: 21px;
}

.title_container_mensaje {
  padding-bottom: 10px;
}
.title_page {
  font-family: Roboto;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #313b44;
}

.container_box {
  width: calc(33.3% - 12px);
  margin-right: 12px;
  margin-bottom: 24px;
}
</style>
